import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.UNIT,
  primaryKey: 'id',
  properties: {
    id: 'int',
    name: 'string',
    note: 'string?',
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
